module.exports = __webpack_public_path__ + "img/hero-bg-mob.5ca4e22.webp";